import { formValueSelector } from 'redux-form';
import { AppState } from 'store';
import {
  PropertyFormPlaceholders,
  TAX_MAPS_FORM,
  EMPTY_VALUE,
} from './TaxMaps.constants';
import {
  Counties,
  USState,
  Cities,
  GetDriversResult,
  TaxMapsSearchResult,
} from './models';
import { ReducerNames } from 'common';

type LocationsType = {
  name: string;
  hobCode: string;
}[];

export const usStateSelector = ({ taxMaps: { usState } }: AppState): USState =>
  usState;

export const resultSelector = ({
  [ReducerNames.TAX_MAPS]: { result },
}: AppState): TaxMapsSearchResult => result;

export const driversSelector = ({
  taxMaps: { driversData },
}: AppState): GetDriversResult => driversData;

export const valueSelector = (state: AppState, fieldName: string) =>
  formValueSelector(TAX_MAPS_FORM)(state, fieldName);

export const getCities = (counties: Counties, countyHob: string) => {
  const county = counties.find(({ hobCode }) => hobCode === countyHob);
  return county ? county.cities : null;
};

export const getVillages = (cities: Cities | null, citieHob: string) => {
  const citie = cities?.find(({ hobCode }) => hobCode === citieHob);
  return citie ? citie.villages : null;
};

const getPlaceHolder = (text: string) => [
  {
    value: EMPTY_VALUE,
    text,
  },
];

const getOptions = (locations: LocationsType) =>
  locations.map(({ name: text, hobCode: value }) => ({
    value,
    text,
  }));

export const getCountyOptions = (counties: Counties) => [
  ...getPlaceHolder(PropertyFormPlaceholders.COUNTY),
  ...getOptions(counties),
];

export const getCityOptions = (counties: Counties, countyHob: string) => {
  const placeHolder = getPlaceHolder(PropertyFormPlaceholders.CITY);
  if (counties && counties.length && countyHob) {
    const county = counties.find(({ hobCode }) => hobCode === countyHob);
    return county && county.cities.length
      ? [
          ...placeHolder,
          ...getOptions(
            county.cities.map((city) =>
              city.name === 'POUGHKEEPSIE'
                ? { ...city, name: 'CITY OF POUGHKEEPSIE' }
                : city,
            ),
          ),
        ]
      : placeHolder;
  }
  return placeHolder;
};

export const getVillageOptions = (cities: Cities | null, cityHob: string) => {
  const placeHolder = getPlaceHolder(PropertyFormPlaceholders.VILLAGE);
  if (cities && cities.length && cityHob) {
    const city = cities.find(({ hobCode }) => hobCode === cityHob);
    return city && city.villages.length
      ? [...placeHolder, ...getOptions(city.villages)]
      : placeHolder;
  }
  return placeHolder;
};

export const getHobCode = ({ countyHob, cityHob }: any) =>
  cityHob || countyHob || EMPTY_VALUE;

export const getSwissCode = (hobCodes: any, counties: Counties) => {
  const county = counties.find(
    (county) => county.hobCode === hobCodes.countyHob,
  );
  // @ts-ignore:
  if (hobCodes.cityHob && county.cities.length) {
    // @ts-ignore:
    const city = county.cities.find(
      (city) => city.hobCode === hobCodes.cityHob,
    );
    // @ts-ignore:
    if (hobCodes.villageHob && city.villages.length) {
      // @ts-ignore:
      const village = city.villages.find(
        // @ts-ignore:
        (village) => village.hobCode === hobCodes.villageHob,
      );
      return village && village.swissCode;
    }
    return city && city.swissCode;
  }
  return county && county.swissCode;
};
